(() => {
  'use strict';
  let manifestPromise;
  const sets = new Map(), cards = new Map();
  const config = () => document.querySelector('[data-binder-builder-config]');
  async function read(url) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 30000);
    try {
      const response = await fetch(url, {signal: controller.signal, credentials: 'omit'});
      if (!response.ok) throw Error('The card catalog could not load. Try again.');
      return await response.json();
    } finally { clearTimeout(timer); }
  }
  async function index() {
    if (!manifestPromise) {
      manifestPromise = read(config().dataset.catalog).then(manifest => {
        if (manifest.schema !== 1 || !Array.isArray(manifest.sets)) throw Error('Catalog version unavailable.');
        for (const card of Object.values(manifest.starters)) cards.set(card.key, card);
        return manifest;
      }).catch(error => { manifestPromise = null; throw error; });
    }
    return manifestPromise;
  }
  async function loadSet(id) {
    const manifest = await index();
    const entry = manifest.sets.find(set => set.id === Number(id));
    if (!entry) return [];
    if (!sets.has(entry.id)) {
      if (!/^binder-catalog-set-\d+\.json$/.test(entry.file)) throw Error('Invalid catalog file.');
      const catalogUrl = new URL(config().dataset.catalog, location.href);
      const url = new URL(entry.file, catalogUrl);
      url.searchParams.set('v', manifest.version);
      sets.set(entry.id, read(url.href).then(data => {
        if (data.id !== entry.id || data.schema !== 1) throw Error('Invalid catalog set.');
        for (const card of data.cards) cards.set(card.key, card);
        return data.cards;
      }).catch(error => { sets.delete(entry.id); throw error; }));
    }
    return sets.get(entry.id);
  }
  async function resolve(keys) {
    const missing = [...new Set(keys.filter(key => key && !cards.has(key)).map(key => Number(key.split(':')[1])))];
    for (let start = 0; start < missing.length; start += 4) await Promise.all(missing.slice(start, start + 4).map(loadSet));
    return keys.map(key => cards.get(key) || null);
  }
  async function pool(species = 0, set = '', progress = () => {}) {
    const manifest = await index();
    const ids = set ? [Number(set)] : species ? manifest.speciesSets[String(species)] || [] : manifest.sets.map(entry => entry.id);
    const result = [];
    for (let offset = 0; offset < ids.length; offset += 4) {
      const batches = await Promise.all(ids.slice(offset, offset + 4).map(loadSet));
      for (const batch of batches) result.push(...batch);
      progress(Math.min(offset + 4, ids.length), ids.length);
    }
    return species ? result.filter(card => card.species.includes(Number(species))) : result;
  }
  window.KillinBinderCatalog = {index, loadSet, resolve, pool, get: key => cards.get(key)};
})();
